<template>
    <AppSection :title="params.messages.title" :b_bottom="params.b_bottom" class="section-articles">
        <template #header_left v-if="params.header_left">
            <div v-html="params.header_left"></div>
        </template>
        <template #header_right v-if="params.header_right">
            <a v-if="params.header_right.link" :href="params.header_right.link">{{ params.header_right.title }}</a>
        </template>
        <template #body>
            <slider-cards
                v-if="isSlider || $mqBelow('TABLET')"
                :params="{
                    slidesPerView: 3,
                    breakpoints: {
                        320: {
                            slidesPerView: 1.2,
                            spaceBetween: 20,
                        },
                        600: {
                            slidesPerView: 2.2,
                            spaceBetween: 20,
                        },
                        768: {
                            slidesPerView: 3,
                            spaceBetween: 20,
                        },
                        1024: {
                            spaceBetween: 30,
                        }
                    },
                }"
            >
                <swiper-slide v-for="(item, i) in items" :key="i">
                    <article-card v-bind="item"/>
                </swiper-slide>
            </slider-cards>
            <div class="container" v-else>
                <div class="articleCardsContainer pt-5 pb-5">
                    <article-card v-for="(item, i) in items" :key="i" v-bind="item"/>
                </div>
            </div>
            <APagination v-if="pagination"
                         :per-page="pagination.res.pageSize"
                         :total-pages="pagination.res.pageCount"
                         :records="pagination.res.elementsCount"
                         :current-page="pagination.res.pageNumber"
                         :messages="pagination.mess"
                         :options="pagenOption"
                         show-more
                         @showMore="showMore"
            />
        </template>
    </AppSection>
</template>

<script>
import {computed, ref} from "vue";
import AppSection from '../AppSection.vue'
import ArticleCard from '../cards/ArticleCard.vue'
import SliderCards from '../SliderCards.vue'
import {SwiperSlide} from 'swiper/vue';
import APagination from "../ui/APagination";
import {useAProgressBar} from "../ui";
import {send} from "../../services/api";

export default {
    name: 'ArticlesSection',
    props: {
        params: {
            type: Object,
            default: () => {
            }
        }
    },
    components: {
        APagination,
        AppSection,
        ArticleCard,
        SliderCards,
        SwiperSlide,
    },
    setup: (props, ctx) => {

        const isSlider = computed(() => {
            return typeof props.params?.isSlider !== "undefined" ? props.params.isSlider : true
        });
        const pagination = ref(props.params.pagination);

        const pagenOption = computed(() => {
            let res = pagination.value.res;
            res.chunk = 5;
            res.edgeNavigation = false;
            res.hideCount = true;
            res.texts = {};
            return res;
        });

        const items = ref(props.params.items);

        const progress = useAProgressBar();
        const showMore = async (nextPage) => {

            progress.show();
            await send(nextPage, {method: "GET"}, {api: 'y'}).then((response) => {
                items.value = [...items.value, ...response[props.params.responseKey].items];
                pagination.value = response[props.params.responseKey].pagination;
                progress.hide();
            });
        }

        return {
            isSlider,
            pagination,
            items,
            pagenOption,
            showMore
        }
    },
}
</script>

<style lang="scss">
.section-articles {
    @include mobile {
        .section__header-col-right {
            display: none;
        }
    }
}

.articleCardsContainer {
    display: grid;
    gap: 30px;
    grid-template-columns: repeat(3, 1fr);
}
</style>
